// SceneLoader.js
var SceneLoader = pc.createScript('sceneLoader');

SceneLoader.attributes.add('currentScene', { type: 'string', default: 'MAIN' });
SceneLoader.attributes.add('rootWorldWrapper', { type: 'entity' });
SceneLoader.attributes.add('player', { type: 'entity' });
SceneLoader.attributes.add('camEntity', { type: 'entity' });

SceneLoader.attributes.add('alreadyLoaded', { type: 'boolean' });

// initialize code called once per entity
SceneLoader.prototype.initialize = function() {
    
    console.log('init camera and controller');
    
    this.app.on('sceneLoader:loadScene', this.loadScene, this);    
    //trigger scene load for debugging
    this.app.mouse.on(pc.EVENT_MOUSEDOWN, this.onMouseDown, this);

    this.sceneSwitchFlag = true;

    this.app.xr.on('start', function () {
        // XR session has started
        console.log('xr start');
    });

    this.app.xr.on('end', function () {
        // XR session has ended
        console.log('xr end');
    });
    
};

SceneLoader.prototype.onMouseDown = function (event) {
    if (event.button === pc.MOUSEBUTTON_LEFT) {
        
        if(this.sceneSwitchFlag) {
            this.app.fire('sceneLoader:loadScene', 'MAIN');
        } else {
            this.app.fire('sceneLoader:loadScene', 'MAIN');
        }
        
        this.sceneSwitchFlag = !this.sceneSwitchFlag;
    }
};


SceneLoader.prototype.loadScene = function (sceneName) {
    console.log('scene:', sceneName, this.app.root.children);
    var that = this;
    
    if(this.currentScene === sceneName) {
        //console.log('show root world');
        this.rootWorldWrapper.enabled = true;
        var spawn = that.app.root.findByTag('spawn')[0];
        that.setSpawn(that, spawn);
    } else {
        //console.log('hide root world');
        this.rootWorldWrapper.enabled = false;
        
        // Get a reference to the scene's root object
        var oldHierarchy = this.app.root.findByName ('Root');

        //remove old scene content if available
        for (var i = 0; i < this.app.root.children.length; i++) {
            if(this.app.root.children[i].name === 'Root') {
                this.app.root.children[i].destroy();
            }
        }

        // Get the path to the scene
        var scene = this.app.scenes.find(sceneName);
        

        this.app.scenes.loadSceneHierarchy(scene.url, function(err, entity) {
            if (!err) {

                that.app.scenes.loadSceneSettings(scene.url, function(err) {

                    if (!err) {
                        
                        var spawn = entity.findByTag('spawn')[0];
                        that.setSpawn(that, spawn);
                        
                        //apply potential scene specific cam settings here
                        
                        var newSceneCam = that.app.root.findByName('Camera');
                        if (newSceneCam) {
                            
                            //setting the targetCam attributes to the VRCamera
                            that.camEntity.camera.clearColor = newSceneCam.camera.clearColor;
                            that.camEntity.camera.nearClip = newSceneCam.camera.nearClip;
                            that.camEntity.camera.farClip = newSceneCam.camera.farClip;
                            newSceneCam.enabled = false;
                            //that.camEntity.camera.startXr(pc.XRTYPE_VR, pc.XRSPACE_LOCAL);
                            
                        }
                        

                    } else {
                        console.error('loadSceneSettings', err);
                    }
                });
                
                
            } else {
                console.error(err);
            }
        });
    }
};

SceneLoader.prototype.setSpawn = function(that, entity) {
    var spawnPosition = entity.getPosition();
    //console.log('spawnPosition', spawnPosition.name, spawnPosition.getPosition());
    that.player.setPosition(spawnPosition.x, that.player.getPosition().y, spawnPosition.z);
    //that.player.setLocalRotation(0,1,1,0);
};

/*
//old scene loading approach
SceneLoader.prototype.loadScene = function(id) {
    //PickerRaycast.prototype.showRoot(false);
    var that = this;
    var path = id+'.json';
    
    console.log(this.rootSceneId , this.currentLoadedSceneId, id);
    
    //load new scene
    if(this.currentLoadedSceneId !== id) {
        this.currentLoadedSceneId = id;
        
        //remove old scene content if available
        for (var i = 0; i < this.app.root.children.length; i++) {
            if(this.app.root.children[i].name === 'Root') {
                this.app.root.children[i].destroy();
            }
        }
        
        if(this.rootSceneId !== id) {
            
            var oldHierarchy = this.app.root.findByName ('Root');
            
            console.log(this);
            
            this.loadScene (id, function () {
                console.log(id);
                
                //oldHierarchy.destroy ();
            });
            
            this.app.loadSceneHierarchy(path, function (err, entity) {
                
                that.app.loadSceneSettings(path, function(err) {
                    if (!err) {
                        var newSceneCam = that.app.root.findByName('Camera');
                        if(newSceneCam) {
                            
                            newSceneCam.enabled = false;
                            //setting the targetCam attributes to the VRCamera
                            that.camEntity.camera.clearColor = newSceneCam.camera.clearColor;
                            that.camEntity.camera.nearClip = newSceneCam.camera.nearClip;
                            that.camEntity.camera.farClip = newSceneCam.camera.farClip;
                            
                            that.camEntity.camera.startXr(pc.XRTYPE_VR, pc.XRSPACE_LOCAL);
                        }
                    } else {
                        console.error('loadSceneSettings', err);
                    }
                });
                that.setSpawn(that, entity.findByTag('spawn')[0]);
            });
            
        }
    }

    if(this.rootSceneId === id) {
        //console.log('show root world');
        this.rootWorldWrapper.enabled = true;
        that.setSpawn(that, that.app.root.findByTag('spawn')[0]);
        
    } else {
        //console.log('hide root world');
        this.rootWorldWrapper.enabled = false;
    }
};
*/


